<template>
  <div class="md-layout md-alignment-center-center callback-container gray-6 bg">
    <p v-if="state.error" class="error">{{ state.error }}</p>
    <router-link v-if="state.error" to="login">Back to login</router-link>
    <h3 v-if="!state.error">Signing you in to Odin...</h3>
    <md-progress-spinner v-if="!state.error" md-mode="indeterminate" />
  </div>
</template>

<script>
import { authResultKey } from '~lib/common/providers/auth';
import { deriveOdinHandoffInitUrl } from '~lib/common/utils/odin';

const readStoredAuthResult = () => {
  try {
    return JSON.parse(localStorage.getItem(authResultKey));
  } catch (error) {
    console.error(error);
    return null;
  }
};

export default {
  name: 'odin-handoff',
  data() {
    return {
      state: {
        error: null,
      },
    };
  },
  mounted() {
    try {
      const { target, state, handoff } = this.$route.query;
      if (!target) {
        throw new Error('Missing Odin callback target.');
      }

      const authResult = readStoredAuthResult();
      if (!authResult || !authResult.idToken) {
        throw new Error('No active authoring session found. Sign in again and retry.');
      }

      const handoffInitUrl = deriveOdinHandoffInitUrl(target, handoff, {
        origin: window.location.origin,
      });
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = handoffInitUrl;
      form.style.display = 'none';

      [
        ['idToken', authResult.idToken || ''],
        ['state', state || ''],
      ].forEach(([name, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
      });

      document.body.appendChild(form);
      form.submit();
    } catch (error) {
      console.error(error);
      this.state.error = error.message || 'Unable to hand off the authoring session to Odin.';
    }
  },
};
</script>

<style>
.callback-container {
  flex-direction: column;
}
</style>
